import React from "react";
import { HeartHandshake } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function OurSacredMission() {
  return <section id="our-sacred-mission" className="bg-background py-24 px-6 md:px-12">
      <div className="mx-auto max-w-[800px] rounded-3xl bg-primary/5 p-8 md:p-16 text-center shadow-sm border border-border/40 backdrop-blur-sm">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight">
          Our Sacred Mission
        </h2>
        
        <div className="flex items-center justify-center gap-4 mb-8">
          <Separator className="w-16 bg-secondary/40" />
          <HeartHandshake className="w-8 h-8 text-secondary shrink-0" strokeWidth={1.5} />
          <Separator className="w-16 bg-secondary/40" />
        </div>
        
        <div className="space-y-6 text-lg md:text-xl text-foreground/80 leading-[1.8] font-sans mb-10">
          <p>To help seniors live their final years with fellowship, faith, and safety within their own homes.</p>
          <p>Our primary mission is to build and sustain a volunteer visitation network of compassionate Orthodox Christians and community members who visit isolated seniors for basic needs checks and to offer friendship, prayer, conversation, and spiritual support.</p>
          <p>
            By providing consistent human presence, we bridge the gap between faith-based charity and civic duty—helping to prevent crises, reduce the need for emergency welfare checks, and allow local law enforcement and EMS to focus their vital resources on core emergencies.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8">
            <Link to="/SeniorAidPortalPage">
              Submit Aid Request
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary/50 text-primary hover:bg-secondary/10 rounded-full px-8">
            <Link to="/VolunteerSignUpPage">
              Become a Volunteer
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}